import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1C35]" data-testid="admin-auth-loading">
        <div className="text-slate-400 text-sm">Checking session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FB] text-slate-700" data-testid="admin-forbidden">
        <div className="text-center">
          <h2 className="font-display font-bold text-2xl">Access denied</h2>
          <p className="mt-2 text-sm text-slate-500">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return children;
}
